<template>
    <div class="matching-products-details__wrapper q-mb-md">
        <div class="matching-products-details">
        <div class="product-gallery">
            <img :src="defaultImage" alt="">
        </div>
        <div>
            <div class="matching-products-details__title q-pb-md">
                {{ product.name }}
            </div>
            <div class="row">
                <div class="col">SKU: <span>{{ product.sku }}</span></div>
                <div class="col">PRICE: <span>{{product?.pricing?.ProductsPrice?.Price}}</span></div>
            </div>
        </div>
        <div class="stock-message">
            <StockMessage :showQuantity='product?.pricing?.ShowStock' :quantity='product?.pricing?.StockQuantity' :message="product?.pricing?.Message" :status='product?.pricing?.StockStatus'/>
        </div>
    </div>
    <div>

        <AddToCartWithQuantity :product="product" />
    </div>
    </div>
</template>

<script setup>
import { defineProps,computed } from "vue";
// eslint-disable-next-line no-unused-vars
import StockMessage from "../ProductResultsTable/StockMessage.vue"
import AddToCartWithQuantity from "./AddToCartWithQuantity.vue"

// eslint-disable-next-line no-unused-vars
const props = defineProps({
    product: Object
})

const defaultImage=computed(()=>{
    return props.product.productImg ? props.product.productImg : "/images/default-image.png";
});
</script>

<style scoped lang="scss">
.product-gallery {
    img {
        width: 75px;
        height: 75px;
    }
    padding-right: 17px;
}

.matching-products-details {
    
    display: flex;
    // justify-content: space-between;

    &__wrapper{
        padding: 12px 13px 10px 12px;
    background: #FEFEFE;
    border: 1px solid #B3B3B3;
    border-radius: 8px;
    }

    &__title {
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: $apg-dark-grey;
    }

    .col {
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: $apg-navigation-grey;
    }

    span {
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.5px;
        color: $apg-dark-grey;
    }
    .stock-message{
        margin-left: auto;
    }
}
</style>